var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 181,
    viewBox: "0 0 194 181",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.443 43.3379L112.44 79.349L112.369 79.4123L112.44 79.4905L152.443 123.928L139.18 135.867L134.955 135.866L134.315 130.402L134.311 130.367L134.287 130.34L129.278 124.775L119.259 113.646L99.2226 91.3887L99.1523 91.3105L99.082 91.3738L59.0336 127.426L54.8015 127.425L54.087 123.697L54.0847 123.685L54.0796 123.673L52.4902 120.074L52.4828 120.058L52.4704 120.044L45.8618 112.703L85.8649 76.6916L85.9352 76.6283L85.8649 76.5501L45.8618 32.1127L52.4704 26.1636L52.4857 26.1498L52.4933 26.1302L54.7929 20.1727L59.0422 20.1736L99.082 64.6519L99.1523 64.7301L99.2226 64.6668L119.259 46.6295L129.278 37.6109L134.287 33.1016L134.31 33.0805L134.315 33.0479L134.951 28.6138L139.189 28.6147L152.443 43.3379Z",
    fill: "#B2001F",
    stroke: "black",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.087 43.315L108.083 79.3347L108.013 79.3981L108.083 79.4762L148.087 123.905L134.869 135.806L94.8655 91.3772L94.7951 91.2991L94.7248 91.3624L54.7209 127.382L41.5034 112.703L81.5074 76.683L81.5777 76.6196L81.5074 76.5415L41.5034 32.1127L54.7209 20.2116L94.7248 64.6405L94.7951 64.7186L94.8655 64.6553L134.869 28.6356L148.087 43.315Z",
    fill: "#FF4C6B",
    stroke: "black",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M96.6211 162.433C124.21 162.433 146.575 159.967 146.575 156.926C146.575 153.884 124.21 151.419 96.6211 151.419C69.0325 151.419 46.6675 153.884 46.6675 156.926C46.6675 159.967 69.0325 162.433 96.6211 162.433Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossError);
export default __webpack_public_path__ + "static/media/cross-error.7b44575e46fb5e3746eb9948009e7bc1.svg";
export { ForwardRef as ReactComponent };